"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HBCalloutFooter = HBCalloutFooter;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _ArrowLineLeft = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowLineLeft16"));
var _ArrowLineRight = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowLineRight16"));
var _ArrowRight = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowRight16"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBButton = _interopRequireDefault(require("../HBButton/HBButton"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _HBLinkButton = _interopRequireDefault(require("../HBLinkButton/HBLinkButton"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _PaginationDots = _interopRequireDefault(require("../common/PaginationDots"));
var _SizeProvider = require("../common/SizeProvider");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var sizeStyles = {
  sm: {
    buttonSize: 'sm',
    footerTopPadding: '8px'
  },
  md: {
    buttonSize: 'md',
    footerTopPadding: '12px'
  },
  lg: {
    buttonSize: 'lg',
    footerTopPadding: '16px'
  }
};
function Carousel(_ref) {
  var steps = _ref.steps,
    setCurrentStep = _ref.setCurrentStep,
    currentStep = _ref.currentStep,
    autoRotate = _ref.autoRotate,
    autoRotateInterval = _ref.autoRotateInterval,
    autoRotateResumeDelay = _ref.autoRotateResumeDelay;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isUserInteracting = _useState2[0],
    setIsUserInteracting = _useState2[1];
  var timeoutRef = (0, _react.useRef)();
  var handleUserInteraction = function handleUserInteraction() {
    setIsUserInteracting(true);

    // Clear existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set a timeout to re-enable autoRotate after 10s
    timeoutRef.current = setTimeout(function () {
      setIsUserInteracting(false);
    }, autoRotateResumeDelay);
  };
  (0, _react.useEffect)(function () {
    return function () {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (!autoRotate || isUserInteracting) {
      return;
    }
    var interval = setInterval(function () {
      setCurrentStep(currentStep < steps.length - 1 ? currentStep + 1 : 0);
    }, autoRotateInterval);
    return function () {
      return clearInterval(interval);
    }; // Cleanup on unmount
  }, [autoRotate, steps.length, setCurrentStep, currentStep, autoRotateInterval, isUserInteracting]);
  return /*#__PURE__*/_react["default"].createElement(FooterButton, null, /*#__PURE__*/_react["default"].createElement(_PaginationDots["default"], {
    count: steps.length,
    activeIndex: currentStep
  }), /*#__PURE__*/_react["default"].createElement(ButtonsContainer, null, /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    label: "Previous",
    testIdName: "callout-card-carousel-previous",
    onClick: function onClick() {
      handleUserInteraction();
      if (currentStep === 0) {
        return;
      }
      setCurrentStep(currentStep - 1);
    },
    disabled: currentStep === 0,
    icon: _ArrowLineLeft["default"]
  }), /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    label: "Next",
    testIdName: "callout-card-carousel-next",
    onClick: function onClick() {
      handleUserInteraction();
      if (currentStep === steps.length - 1) {
        return;
      }
      setCurrentStep(currentStep + 1);
    },
    disabled: currentStep === steps.length - 1,
    icon: _ArrowLineRight["default"]
  })));
}
function Buttons(_ref2) {
  var ctaText = _ref2.ctaText,
    onCtaClick = _ref2.onCtaClick,
    onSecondaryCtaClick = _ref2.onSecondaryCtaClick,
    secondaryCtaText = _ref2.secondaryCtaText,
    steps = _ref2.steps,
    setCurrentStep = _ref2.setCurrentStep,
    currentStep = _ref2.currentStep;
  var size = (0, _SizeProvider.useSize)();
  var primaryCtaClick = !!steps ? function () {
    if (currentStep === steps.length - 1) {
      return;
    }
    setCurrentStep(currentStep + 1);
  } : onCtaClick;
  var secondaryCtaClick = !!steps ? function () {
    if (currentStep === 0) {
      return;
    }
    setCurrentStep(currentStep - 1);
  } : onSecondaryCtaClick;
  var primaryCtaDisabled = !!steps ? currentStep === steps.length - 1 : false;
  var secondaryCtaDisabled = !!steps ? currentStep === 0 : false;
  return /*#__PURE__*/_react["default"].createElement(FooterButton, null, /*#__PURE__*/_react["default"].createElement(ButtonsContainer, null, /*#__PURE__*/_react["default"].createElement(_HBButton["default"], {
    testIdName: "callout-card-cta",
    onClick: primaryCtaClick,
    size: sizeStyles[size].buttonSize,
    disabled: primaryCtaDisabled
  }, ctaText), secondaryCtaText && /*#__PURE__*/_react["default"].createElement(_HBButton["default"], {
    testIdName: "callout-card-secondary-cta",
    onClick: secondaryCtaClick,
    buttonTheme: "secondary-invisible-primary",
    size: sizeStyles[size].buttonSize,
    disabled: secondaryCtaDisabled
  }, secondaryCtaText)), !!(steps !== null && steps !== void 0 && steps.length) && /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "subtitle12",
    color: "textTertiary",
    transform: "uppercase"
  }, currentStep + 1, " of ", steps.length));
}
function HBCalloutFooter(_ref3) {
  var action = _ref3.action,
    actionsProps = _ref3.actionsProps,
    setCurrentStep = _ref3.setCurrentStep,
    currentStep = _ref3.currentStep,
    steps = _ref3.steps,
    autoRotate = _ref3.autoRotate,
    autoRotateInterval = _ref3.autoRotateInterval,
    autoRotateResumeDelay = _ref3.autoRotateResumeDelay;
  var size = (0, _SizeProvider.useSize)();
  if (!action) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(Footer, null, action === 'button' && /*#__PURE__*/_react["default"].createElement(Buttons, (0, _extends2["default"])({}, actionsProps, {
    currentStep: currentStep,
    setCurrentStep: setCurrentStep,
    steps: steps
  })), action === 'link-button' && /*#__PURE__*/_react["default"].createElement(_HBLinkButton["default"], {
    size: sizeStyles[size].buttonSize,
    testIdName: "link-button",
    onClick: actionsProps.onClick,
    icon: /*#__PURE__*/_react["default"].createElement(_ArrowRight["default"], null),
    iconPosition: "end"
  }, actionsProps.text), action === 'carousel' && !!steps && /*#__PURE__*/_react["default"].createElement(Carousel, (0, _extends2["default"])({}, actionsProps, {
    currentStep: currentStep,
    setCurrentStep: setCurrentStep,
    steps: steps,
    autoRotate: autoRotate,
    autoRotateInterval: autoRotateInterval,
    autoRotateResumeDelay: autoRotateResumeDelay
  })));
}

// -------------------------------- Styles -------------------------------- //
var Footer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutFooter__Footer",
  componentId: "sc-1g1d3nc-0"
})(["padding-top:", ";"], function (props) {
  return sizeStyles[props.theme.size].footerTopPadding;
});
var FooterButton = (0, _styledComponents["default"])(Footer).withConfig({
  displayName: "HBCalloutFooter__FooterButton",
  componentId: "sc-1g1d3nc-1"
})(["display:flex;justify-content:space-between;align-items:center;"]);
var ButtonsContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutFooter__ButtonsContainer",
  componentId: "sc-1g1d3nc-2"
})(["display:flex;gap:8px;"]);
//# sourceMappingURL=HBCalloutFooter.js.map